import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	mappingModalFooterBack: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-footer-back',
		defaultMessage: 'Back',
		description: 'title for mapping modal table back button in modal footer',
	},
	mappingModalPaginatorSummary: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-paginator-summary',
		defaultMessage:
			'Showing {startRow} - {endRow} of {totalRows, plural, one {# priority scheme} other {# priority schemes}}',
		description:
			'Summary of current rows being shown in the table. {startRow} and {endRow} is the limit of rows currently visible on the table (e.g. 1 to 5). {totalRows} is total count of priority schemes available for this Jira instance (e.g. 70).',
	},
	mappingModalReturnModalButtonLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-return-modal-button-label',
		defaultMessage: 'go back icon',
		description: 'icon label to return to previous edit or create priority scheme modal',
	},
	mappingModalPaginationNextButtonLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-pagination-next-button-label',
		defaultMessage: 'Next',
		description: 'the aria-label for next button for pagination button',
	},
	mappingModalPaginationWrapperLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-pagination-wrapper-label',
		defaultMessage: 'Pagination',
		description: 'the aria-label for the pagination nav wrapper',
	},
	mappingModalPaginationPageLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-pagination-page-label',
		defaultMessage: 'Page',
		description:
			'The aria-label for the individual page numbers. The default value is "page". The page number is automatically appended to the pageLabel. For Example, pageLabel="página" will render aria-label="página 1" as the label for page 1.',
	},
	mappingModalPaginationPreviousButtonLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-pagination-previous-button-label',
		defaultMessage: 'Page',
		description: 'The aria-label for the previous button.',
	},
	mappingModalUnexpectedErrorTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-unexpected-error-title',
		defaultMessage: 'Unexpected Error',
		description: 'Title for section message when there is an unexpected error',
	},
});

export default messages;
